<div class="services-box">
	<ng-container *ngIf="!isLoading; else loading">
		<div class="services-title-bar" translate>{{ headerLabel }}</div>
		<button [routerLink]="btnRouterLink"
			type="button"
			mat-button color="primary"
			class="services-label">
			<span class="widget-resize-double-line" translate>{{ btnLabel }}</span>
			<mat-icon iconPositionEnd class="service-icon copo-small-icon-button" svgIcon="plus_icon"></mat-icon>
		</button>
	</ng-container>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>